module.exports = __webpack_public_path__ + "db67369e9718fcd7a362d920a6a27015.png";